module.exports = __webpack_public_path__ + "static/img/introduce_14.7bb30ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_14.png
// module id = FaXU
// module chunks = 1